// Default to a relative "/api" so requests always hit the same origin the app is
// served from. REACT_APP_API_URL can override it (e.g. the dev server proxies /api).
export const API_URL = process.env.REACT_APP_API_URL || "/api";
export const APP_NAME = process.env.REACT_APP_NAME;
export const APP_NAME_SIMKEHILOT = "simkehilot";
export const APP_NAME_SIMEHADRIN = "simehadrin";
export const APP_NAME_MERKAZIA = "merkazia";

// map a hostname to a brand name, or null when nothing matches.
function matchBrand(value) {
  const v = String(value || "").toLowerCase();
  if (v.includes("mehadrin")) return APP_NAME_SIMEHADRIN;       // simehadrin / sim-mehadrin
  if (v.includes("merkazia")) return APP_NAME_MERKAZIA;         // merkazia
  if (v.includes("kehilot") || v.includes("kehila")) return APP_NAME_SIMKEHILOT; // simkehilot / sim-kehilot
  return null;
}

// Active brand — determined solely by the hostname the app is served from
// (e.g. simehadrin.yemot.co.il → simehadrin). Falls back to the build-time
// APP_NAME only when the hostname doesn't match any known brand.
export function getActiveAppName() {
  let host = "";
  try { host = window.location.hostname; } catch (e) {}
  return matchBrand(host) || APP_NAME;
}

// Human-readable site name per brand (shown in the browser tab, headers, etc.).
const BRAND_DISPLAY_NAMES = {
  [APP_NAME_SIMKEHILOT]: "סים קהילות",
  [APP_NAME_SIMEHADRIN]: "סים מהדרין",
  [APP_NAME_MERKAZIA]: "מרכזיה",
};
export function getBrandDisplayName() {
  const brand = getActiveAppName();
  return BRAND_DISPLAY_NAMES[brand] || brand;
}

// Customer-service phone per brand.
const BRAND_SUPPORT_PHONES = {
  [APP_NAME_SIMKEHILOT]: "1599-500-500",
  [APP_NAME_SIMEHADRIN]: "1599-500-111",
  [APP_NAME_MERKAZIA]: "08-320-2222",
};
export function getSupportPhone() {
  return BRAND_SUPPORT_PHONES[getActiveAppName()] || "1599-500-500";
}

// favicon URL for the active brand — taken from the brand's own index folder.
export function getBrandFavicon() {
  const brand = getActiveAppName();
  if (brand === APP_NAME_SIMKEHILOT || brand === APP_NAME_SIMEHADRIN || brand === APP_NAME_MERKAZIA) {
    return "/index-" + brand + "/favicon.ico";
  }
  return "/favicon.ico";
}

// Logo URL for the active brand. forNav=true returns the menu-strip logo.
export function getBrandLogo(forNav = false) {
  const brand = getActiveAppName();
  if (brand === APP_NAME_SIMEHADRIN) return "/design-images/simehadrin/logo.svg";
  return forNav ? "/design-images/" + brand + "/logo-for-menu.png" : "/design-images/" + brand + "/logo.png";
}
export const API_OK = "OK";
export const ACTION_ADD = "add";
export const ACTION_EDIT = "edit";
export const CALL_TYPE_IN = "IN";
export const ALL = "ALL"; 
export const CALL_TYPE_OUT = "OUT";
export const CALL_TYPE_ALL = "ALL";
export const STATUS_BLOCKED = "BLOCKED";
export const STATUS_OPEN = "OPEN";
export const API_EXCEPTION = "Exception";
export const DEFAULT_ERROR_TITLE = "Error";
export const DEFAULT_ERROR_TEXT = "Error ocurred during operation";
export const ERROR_SESSION_EXPIRED = "SESSION_EXPIRED";
export const ERROR_BAD_SESSION = "BAD_SESSION";
export const ERROR_BAD_ID = "BAD_ID";
export const ERROR_BAD_NEW_OBJ = "BAD_NEW_OBJ";
export const ERROR_NUMBERS_TO_PERFORM_REQUIRED = "NUMBERS_TO_PERFORM_REQUIRED";
export const ERROR_NO_CHANGES_WERE_MADE = "NO_CHANGES_WERE_MADE";
export const ERROR_BAD_REQUEST = "BAD_REQUEST";
export const INCORRECT_LOGIN = "INCORRECT_LOGIN";
export const LIABILITY_POPUP_APPROVED = "liability_popup_approved";
export const CLOCK_STATUS_ON = "ON";
export const CLOCK_STATUS_BLOCKED = "BLOCKED";
export const CLOCK_STATUS_OPEN = "OPEN";
export const CLOCK_STATUS_CLOSED = "CLOSE";
export const CLOCK_STATUS_CALLS_ALL = "ALL";
export const CLOCK_STATUS_CALLS_IN = "IN";
export const CLOCK_STATUS_CALLS_OUT = "OUT";
export const LINE_STATUS_ACTIVE = "ACTIVE";
export const CALL_TYPE_INCOMING = "IN";
export const CALL_TYPE_OUTCOMING = "OUT";
export const BLOCK_LIST_MODE_BLACKLIST = "BLACKLIST";
export const BLOCK_LIST_MODE_WHITELIST = "WHITELIST";
export const BLOCK_LIST_MODE_INHERIT = "INHERITANCE";
export const WATCH_STATUS_ON = "ON";
export const WATCH_STATUS_BLOCKED = "BLOCKED";
export const WATCH_STATUS_OPEN = "OPEN";
export const WATCH_STATUS_CLOSED = "CLOSE";
export const WATCH_STATUS_CALLS_ALL = "ALL";
export const WATCH_STATUS_CALLS_IN = "IN";
export const WATCH_STATUS_CALLS_OUT = "OUT";
export const WATCH_TYPE_CALL = "CALL";
export const WATCH_TYPE_SMS = "SMS";
export const CUSTOMER_VIEW_BLOCK = "blocks";
export const CUSTOMER_VIEW_CUSTOMER = "customer";
export const CUSTOMER_VIEW_CUSTOMERS_LIST = "customers_list";
export const CUSTOMER_VIEW_WATCH = "customer_watch";
export const CATEGORY_VIEW_CATEGORY = "category";
export const CATEGORY_VIEW_CATEGORIES_LIST = "categories_list";